import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=6b55a351&scoped=true&"
import script from "./Google.vue?vue&type=script&lang=js&"
export * from "./Google.vue?vue&type=script&lang=js&"
import style0 from "./Google.scss?vue&type=style&index=0&id=6b55a351&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b55a351",
  null
  
)

export default component.exports